import React from 'react';

import { useFieldValue } from 'Shared/utils/hooks';
import DiscussionTopicsEmptyState from './DiscussionTopicsEmptyState/DiscussionTopicsEmptyState';
import { WpIcon } from 'Wpds/components/icon';

export default function DiscussionTopicsListPreview() {
  const discussionTopics = useFieldValue('discussionTopics');
  const checkedDiscussionTopics = discussionTopics
    .filter(item => item.label && (item.checked || item.freeze))
    .map(item => item.label);
  return checkedDiscussionTopics.length ? (
    <div className="d-flex flex-column w-100 mt-2 ">
      <div className="mb-2 ">Discussion Topics</div>
      <div className="onboarding-workspaces-preview-content-discussion-topics scrollbar">
        {checkedDiscussionTopics.map(discussionTopic => (
          <div
            key={`discussion-topic-${discussionTopic}`}
            className="onboarding-workspaces-preview-content-discussion-topic"
          >
            <span className="mr-2">
              <WpIcon name="check-circle" />
            </span>
            <p className="m-0">{discussionTopic}</p>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <DiscussionTopicsEmptyState />
  );
}
